export default "__VITE_ASSET__DOK3qUVo__"